import styled from 'styled-components';
import { lightGray } from '../../theme.selectors';

export const Divider = styled.hr`
  color: ${lightGray};
  margin-bottom: 8px;
  border-style: ridge;
`;
